import { FetchInterceptor } from "src/app/helpers/Index";
import { environment } from "src/environments/environment";

const endpoint = "SaleWindow";
const json = { "Content-Type": "application/json" };
const url = (path: string) => `${environment.server.apiURL}/${endpoint}${path}`;

/** What a sale window is attached to. Matches SaleWindowParentEnum. */
export const SaleWindowParent = { SeasonTicketProduct: 0, Fixture: 10, Event: 20 };

/** Where a window is in its life. Matches SaleWindowStatusEnum. */
export const SaleWindowStatus = { Draft: 0, OnSale: 10, Renewal: 20, Archived: 30 };

export const SALE_WINDOW_STATUS_LABELS: { [key: number]: string } = {
	0: "Draft", 10: "On sale", 20: "Renewal", 30: "Archived"
};

/** Sale windows: when something is on sale, as distinct from what it admits you to. */
export const SaleWindowService = {
	endpoint,
	status: async () => await FetchInterceptor(url("/Status"), {headers: json, method: "GET"}),
	getForParent: async (parentType: number, parentId: number) =>
		await FetchInterceptor(url(`/${parentType}/${parentId}`), {headers: json, method: "GET"}),
	add: async (parentType: number, parentId: number, data: any) =>
		await FetchInterceptor(url(`/${parentType}/${parentId}`), {body: JSON.stringify(data), headers: json, method: "POST"}),
	update: async (id: number, data: any) =>
		await FetchInterceptor(url(`/${id}`), {body: JSON.stringify(data), headers: json, method: "POST"}),
	remove: async (id: number) => await FetchInterceptor(url(`/${id}`), {headers: json, method: "DELETE"}),
	/** The window a purchase would be attributed to right now. */
	getCurrent: async (parentType: number, parentId: number, forFans = false) =>
		await FetchInterceptor(url(`/${parentType}/${parentId}/Current?forFans=${forFans}`), {headers: json, method: "GET"})
}
